import { GraphQLClient as GQLClient } from "graphql-request";

class AuthenticatedGraphQLClient {
  private client: GQLClient;

  constructor(endpoint: string) {
    this.client = new GQLClient(endpoint);
  }

  async request<T = any>(
    query: string,
    variables?: Record<string, any>,
    token?: string | null,
  ): Promise<T> {
    try {
      if (!token) {
        throw new Error("No authentication token available. Please authenticate first.");
      }

      // Set the authorization header
      this.client.setHeader("Authorization", `Bearer ${token}`);

      // Make the GraphQL request
      const data = await this.client.request<T>(query, variables);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error("Unknown error occurred during GraphQL request");
    }
  }
}

// Create a singleton instance
const graphqlClient = new AuthenticatedGraphQLClient(import.meta.env.VITE_API_URL);

export default graphqlClient;
